
import { Component, Mixins, Watch } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import LoadableMixin from '@/mixins/LoadableMixin';

@Component({
    components: {},
    mixins: [ModelMixin],
})
export default class LoginSettingsPopup extends Mixins<LoadableMixin, ModelMixin<boolean>>(LoadableMixin, ModelMixin) {
    selectedSetting = '1';

    @Watch('model', { immediate: true })
    onModelChange(newValue: boolean, oldValue: boolean) {
        if (newValue && !oldValue) {
            this.selectedSetting = '1';
        }
    }
}
